import config, { path } from "../config/enviroment";
import { StorageService } from "./storage";
import axios, { CancelToken } from "axios";

export class DataService {

  private defaultLanguage: string; 

  constructor(defaultLanguage: string = 'esp') {
    this.defaultLanguage = defaultLanguage;
  }

  get(endpoint: string, body = null) {
    let trama = {
      headerIn: this.headerIn(),
      bodyIn: body,
    };
    const requestOptions: any = {
      method: "POST",
      headers: this.header(),
      body: JSON.stringify(trama),
    };
    let api_endpoint = config.api + endpoint;

    return axios.get(api_endpoint, requestOptions);
  }

  post(endpoint: string, body: any | null = null, cancelToken?: CancelToken, version = 2) {
    const option = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Language": (this.defaultLanguage == 'ESP') ? 'es':'en',
        version:version,

      },
      cancelToken,
    };
    
    let api_endpoint = config.api + endpoint;
    return axios.post(api_endpoint, body, option)
  }

  header() {
    let header = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return header;
  }

  headerIn() {
    let token = new StorageService().getSession();
    let headerIn = config.headerIn;
    if (token) {
      headerIn.token = token;
    }
    return headerIn;
  }

  /* Conexiones a elastic search */

  postElastic(
    endpoint: string,
    body: any | null = null,
    filter: any | null = null,
    version = 2
  ) {
    const option = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        version:version
      },
    };
    let api_body;

    if (filter !== null) {
      api_body = filter;
    } else {
      api_body = {
        url: path,
        filter: {
          ...body,
          origin: config.landingIdentifier,
          [body.name]: body.value,
        },
        optimice: true,
      };
    }

    let api_endpoint = config.apiElastic + endpoint;
    return axios.post(api_endpoint, api_body, option);
  }
}
